// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "7f297f8e8f9e5c5d8cb7" + ".js";
};